<ng-container *ngIf="isFnBApp; else other">
    <div class="card" (click)="onOrderClick()">
        <div class="card-header">
            <h5 class="card-title text-gray-500">{{ ('order' | transloco) + ': ' + order.order_code }}</h5>
            <p *ngIf="OrderStateData[order.current_state] as state">
                <tui-tag size="s" [value]="state.label | transloco" [class]="state.className" status="custom"></tui-tag>
            </p>
        </div>
        <div class="card-content">
            <div class="pr-4">
                <div class="border-b border-gray-100 mb-3 pb-2 text-gray-600"></div>
                <div class="flex justify-between gap-1">
                    <p class="font-medium text-[16px] md:text-lg my-1 w-[70%]">
                        {{ orderItemsPreview }}
                    </p>
                    <p class="font-medium text-[14px] md:text-lg my-1">
                        {{ order.grand_total | formatCurrency }}
                    </p>
                </div>
                <!-- <p class="lowercase">
                    {{ order.grand_total | formatCurrency }} | {{ order.items.length }} {{ 'product' | transloco }}
                </p> -->
                <p class="text-sm text-gray-600">
                    <span>{{ order.created_at || order.booking_time | dfnsParseIso | dfnsFormat : 'p, iiii P' }}</span>
                </p>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #other>
    <div
        class="shadow border border-gray-300 hover:border-gray-400 mb-5 p-3 relative cursor-pointer rounded-xl"
        (click)="onOrderClick()"
    >
        <div class="pr-4">
            <div class="border-b border-gray-100 mb-3 pb-2 text-gray-600">
                <p *ngIf="OrderStateData[order.current_state] as state">
                    <tui-tag
                        size="s"
                        [value]="state.label | transloco"
                        [class]="state.className"
                        status="custom"
                    ></tui-tag>
                </p>

                <p class="text-sm">
                    {{ ('order' | transloco) + ': ' + order.order_code }}

                    <span class="ml-2">{{
                        order.created_at || order.booking_time | dfnsParseIso | dfnsFormat : 'p, iiii P'
                    }}</span>
                </p>
            </div>

            <p class="font-medium text-lg my-1">
                {{ orderItemsPreview }}
            </p>

            <p class="lowercase">
                {{ order.grand_total | formatCurrency }}| {{ order.items.length }} {{ 'product' | transloco }}
            </p>
        </div>

        <span class="absolute top-1/2 right-3 font-medium text-lg text-gray-600">
            <tui-svg src="svg::arrow-small-right"></tui-svg>
        </span>
    </div>
</ng-template>
